import { INFO_BLOCK_FONT_SIZE, INFO_BLOCK_SIZE } from "../constants";
import { settings } from "../settings/settings";
export const qtId = (id) => `QT_${id}`;
export const getQT = (id) => l(qtId(id));
export const setVisible = (el, visible, displayWhenVisible = "flex") => {
    if (!el)
        return;
    el.style.display = visible ? displayWhenVisible : "none";
};
export const applyInfoBlockScale = (el, scale = settings.guiScale) => {
    el.style.height = `${scale * INFO_BLOCK_SIZE}px`;
    el.style.fontSize = `${scale * INFO_BLOCK_FONT_SIZE}px`;
};
export const getAltStackingWidth = () => `calc(100% - ${20 + (settings.showOldBuffTImers ? 50 : 0)}px)`;
export const applyAltStacking = (enabled) => {
    const container = l("QTContainer");
    if (!container)
        return;
    if (enabled) {
        container.classList.add("qt_altStacking");
        container.style.width = getAltStackingWidth();
    }
    else {
        container.classList.remove("qt_altStacking");
        container.style.width = "";
    }
};
export const scaleAllInfoBlocks = (scale = settings.guiScale) => {
    const container = l("QTContainer");
    if (!container)
        return;
    container.querySelectorAll("div").forEach((div) => {
        applyInfoBlockScale(div, scale);
    });
};
